export enum PaymentSuccessDialogReferrer {
  MatchDailyStatistics = 'MATCH_DAILY_STATISTICS',
}
